// @file Content picker container size store
import { defineContainerSizeStore } from '@@/pinia/container_size_store_builder'

export const useContentPickerContainerSizeStore = defineContainerSizeStore('contentPickerContainerSize')
